import { Typography } from 'antd'
import { noop } from 'lodash'
import { StyledCell, StyledTableRow } from './Table.styled'

const TableRows = ({ rows = [], prepareRow = noop, onRowClicked }) => {
  return rows.map((row, idx) => {
    prepareRow(row)

    return (
      <StyledTableRow
        key={`row-${idx}`}
        role="row"
        aria-rowindex={idx + 1}
        rowHover={Boolean(onRowClicked)}
      >
        {row.cells.map((cell, cellIdx) => (
          <StyledCell
            key={`cell-${cellIdx}`}
            role="cell"
            width={cell.column.width}
            alignment={cell.column.alignment}
            onClick={() => {
              if (!['selection', 'menu'].includes(cell.column.id)) {
                onRowClicked && onRowClicked(idx, row)
              }
            }}
          >
            <Typography.Paragraph ellipsis={cell.column.ellipsis || true}>
              {cell.render('Cell')}
            </Typography.Paragraph>
          </StyledCell>
        ))}
      </StyledTableRow>
    )
  })
}

export default TableRows
